import { Component } from 'react';
import { fetchDrivers } from 'actions/Drivers';
import { fetchZones } from 'actions/Zones';
import { fetchDeliveryTypes } from 'actions/DeliveryTypes';
import { connect } from 'react-redux';
import Datetime from 'react-datetime';
import moment from 'moment';
import { isDatepickerValidDay } from 'helpers/dateHelpers';
import SelectAll from 'components/SelectAll';
// components
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
// styles
import { combineStyles, isGranted } from 'helpers/helpers';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import { Dialog, DialogContent } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import AccessDenied from 'components/Security/AccessDenied';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import CardWrapper from 'components/Card/CardWrapper';
import { toast } from 'react-toastify';
import { apiErrorToast } from 'utils/apiError';
import DEFAULT_SALES_MARKET_LANG from 'constants/defaultSalesMarketLang';

import SelectInput from '../../components/FormSelect/SelectInput';
import axios from '../../helpers/gastro';
import roles, { ROLE_SHOW_REPORT_FOR_DRIVER } from '../../helpers/roles';
import ReportConfigurator from '../../components/Report/ReportConfigurator';
import Archive from '../../components/Archive/Archive';
import { fetchZoneCategories } from '../../actions/ZoneCategories';
import DownloadReportButtons from './DownloadReportButtons/DownloadReportButtons';
import MIME_TYPES from './constants/mimeTypes';
import MIME_TYPES_DATA from './constants/mimeTypesData';
import ReportPreview from './ReportPreviev/ReportPreview';
import { FILE_REPORT_MODE } from './constants/fileMode';

const customSelectStyles = {
  height: '32px',
};

class ForDriver extends Component {
  state = {
    selectedBrands: [],
    selectedDrivers: [],
    selectedZones: [],
    selectedDeliveryType: '',
    selectedDeliveryPoint: false,
    dateFrom: '',
    dateTo: '',
    isGenerating: false,
    isGeneratingPreview: false,
    isLoading: false,
    selectedZoneCategories: [],
    filteredZones: null,
    filePreview: '',
    excelContent: {},
    isReportPreviewOpen: false,
  };

  componentDidMount = () => {
    this.setState({
      isLoading: true,
    });

    const loader = [
      this.props.fetchDrivers(),
      this.props.fetchZones(),
      this.props.fetchDeliveryTypes(),
    ];

    if (isGranted(roles.ROLE_SHOW_ZONE_CATEGORY)) {
      loader.push(this.props.fetchZoneCategories());
    }
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    Promise.all(loader).then(() => {
      this.setState({
        isLoading: false,
      });
    });
  };

  filterZonesBasedOnChosenCategory = async () => {
    const zoneCategoriesIds = [];
    this.state.selectedZoneCategories.forEach(zoneCategory => {
      if (!isNaN(zoneCategory.value)) {
        zoneCategoriesIds.push(zoneCategory.value);
      }
    });

    const filteredZones = this.props.zones.filter(zone =>
      zoneCategoriesIds.includes(zone?.category?.id)
    );

    await this.setState({ filteredZones });
    const selected = filteredZones.map(zone => ({
      label: zone.name,
      value: zone['@id'],
    }));
    this.setState({ selectedZones: selected });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.selectedZoneCategories.length !==
      this.state.selectedZoneCategories.length
    ) {
      this.filterZonesBasedOnChosenCategory();
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  validateDate = () => this.state.dateFrom && this.state.dateTo;

  getReportFileName = extension => {
    const title = this.props.t('common.mainMenu.reportsForDriver');

    return `${title.replaceAll(' ', '_')}-${this.state.dateFrom}-${
      this.state.dateTo
    }_(${moment().format('YYYY-MM-DD_HH.mm')}).${extension}`;
  };

  downloadPdf = () => {
    const link = document.createElement('a');
    link.href = this.state.filePreview;
    link.setAttribute('download', this.getReportFileName('pdf'));

    document.body.appendChild(link);
    link.click();
  };

  // eslint-disable-next-line consistent-return -- FIXME
  handlePreviewGenerate = (mimeType, lang, mode) => {
    if (!this.validateDate()) {
      this.setState({ isGeneratingPreview: false });
      return toast.error(this.props.t('reports.sDate'));
    }

    this.setState({ isGeneratingPreview: true });

    const {
      dateFrom,
      dateTo,
      selectedZones,
      selectedDeliveryPoint,
      selectedDrivers,
    } = this.state;

    const params = {
      dateFrom,
      dateTo,
      zones: selectedZones.map(zone => zone.value).filter(val => val !== '*'),
      'delivery-point': selectedDeliveryPoint,
      drivers: selectedDrivers
        .map(driver => driver.value)
        .filter(val => val !== '*'),
      pagination: false,
    };

    const isPdfMode = mode === FILE_REPORT_MODE.pdf;

    const handleChangeState = content => {
      this.setState({
        excelContent: isPdfMode ? {} : content,
        filePreview: isPdfMode ? content : '',
        isGeneratingPreview: false,
        isReportPreviewOpen: true,
      });
    };

    axios
      .get('reports/delivery', {
        responseType: 'blob',
        params,
        headers: { accept: isPdfMode ? mimeType : MIME_TYPES.json },
        forcedLanguage: lang,
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(
        async response => {
          if (response.data) {
            if (isPdfMode) {
              const url = window.URL.createObjectURL(
                new Blob([response.data], { type: mimeType })
              );

              handleChangeState(url);
            } else {
              const text = await response.data.text();
              const excelContent = JSON.parse(text);

              handleChangeState(excelContent);
            }
          } else {
            toast.error(this.props.t('reports.noAccess'));
          }
        },
        // eslint-disable-next-line promise/prefer-await-to-callbacks -- FIXME
        error => {
          apiErrorToast(this.props.t('reports.cannotGenerate'), error);
          this.setState({ isGeneratingPreview: false });
        }
      )
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .finally(() => {
        this.setState({ isGeneratingPreview: false });
      });
  };

  // eslint-disable-next-line consistent-return -- FIXME
  handleGenerate = (mimeType, lang) => {
    this.setState({ isGenerating: true });
    if (!this.validateDate()) {
      this.setState({ isGenerating: false });
      return toast.error(this.props.t('reports.sDate'));
    }

    const {
      dateFrom,
      dateTo,
      selectedZones,
      selectedDeliveryPoint,
      selectedDrivers,
    } = this.state;

    const params = {
      dateFrom,
      dateTo,
      zones: selectedZones.map(zone => zone.value).filter(val => val !== '*'),
      'delivery-point': selectedDeliveryPoint,
      drivers: selectedDrivers
        .map(driver => driver.value)
        .filter(val => val !== '*'),
      pagination: false,
    };

    axios
      .get('reports/delivery', {
        responseType: 'blob',
        params,
        headers: { accept: mimeType },
        forcedLanguage: lang,
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(
        response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            this.getReportFileName(MIME_TYPES_DATA[mimeType].extension)
          );

          document.body.appendChild(link);
          link.click();
          this.setState({ isGenerating: false });
        },
        // eslint-disable-next-line promise/prefer-await-to-callbacks -- FIXME
        error => {
          apiErrorToast(this.props.t('reports.cannotGenerate'), error);
          this.setState({ isGenerating: false });
        }
      )
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .finally(() => {
        this.setState({ isGenerating: false });
      });
  };

  render() {
    const { classes, company, drivers, zoneCategories, zones } = this.props;

    const {
      dateFrom,
      dateTo,
      excelContent,
      filePreview,
      filteredZones,
      isGenerating,
      isGeneratingPreview,
      isReportPreviewOpen,
      selectedBrands,
      selectedDeliveryPoint,
      selectedDrivers,
      selectedZoneCategories,
      selectedZones,
    } = this.state;

    // eslint-disable-next-line radix -- FIXME
    const companyId = parseInt(company.split('/').pop());

    return isGranted(ROLE_SHOW_REPORT_FOR_DRIVER) ? (
      <>
        <CardWrapper
          title={
            <>
              {this.props.t('reports.reportForDriver')}
              <ReportConfigurator
                companyId={companyId}
                report="Delivery"
                fields={[
                  {
                    size: 12,
                    field: 'extendedUserInfo',
                    inputType: 'select',
                    inputProps: {
                      multiple: false,
                      options: [
                        {
                          value: true,
                          label: this.props.t(
                            'configuration.reports.report.Delivery.extendedUserInfo.yes'
                          ),
                        },
                        {
                          value: false,
                          label: this.props.t(
                            'configuration.reports.report.Delivery.extendedUserInfo.no'
                          ),
                        },
                      ],
                    },
                  },
                  {
                    size: 12,
                    field: 'addColumnWithV2Code',
                    inputType: 'select',
                    inputProps: {
                      multiple: false,
                      options: [
                        {
                          value: true,
                          label: this.props.t(
                            'configuration.reports.report.Delivery.addColumnWithV2Code.yes'
                          ),
                        },
                        {
                          value: false,
                          label: this.props.t(
                            'configuration.reports.report.Delivery.addColumnWithV2Code.no'
                          ),
                        },
                      ],
                    },
                  },
                  {
                    size: 12,
                    field: 'showUserEmail',
                    inputType: 'select',
                    inputProps: {
                      multiple: false,
                      options: [
                        { value: true, label: this.props.t('common.yes') },
                        { value: false, label: this.props.t('common.no') },
                      ],
                    },
                  },
                  {
                    size: 12,
                    field: 'mode',
                    inputType: 'select',
                    inputProps: {
                      multiple: false,
                      options: ['BAG', 'POINT'].map(option => ({
                        value: option,
                        label: this.props.t(
                          `configuration.reports.report.Delivery.mode.${option}`
                        ),
                      })),
                    },
                  },
                ]}
              />
            </>
          }
          style={{ marginTop: '20px' }}
        >
          <Dialog open={this.state.isLoading}>
            <DialogContent>
              <div style={{ textAlign: 'center' }}>
                <h1>{this.props.t('common.loader')}</h1>
                <CircularProgress />
              </div>
            </DialogContent>
          </Dialog>
          <Dialog open={isGenerating || isGeneratingPreview}>
            <DialogContent>
              <div style={{ textAlign: 'center' }}>
                <h1>
                  {isGeneratingPreview
                    ? this.props.t('reports.generatePreview.loader')
                    : this.props.t('reports.generate')}
                </h1>
                <CircularProgress />
              </div>
            </DialogContent>
          </Dialog>
          <CardBody>
            <GridContainer>
              <GridItem sm={3}>
                <FormLabel className={classes.labelHorizontal}>
                  {this.props.t('reports.forDriver.dateFrom')} *
                </FormLabel>
                <FormControl fullWidth={true}>
                  <Datetime
                    className="input-datetime--date-from"
                    isValidDate={isDatepickerValidDay}
                    timeFormat={false}
                    dateFormat={moment.localeData().longDateFormat('L')}
                    closeOnSelect={true}
                    // eslint-disable-next-line new-cap -- FIXME
                    value={new moment(this.state.dateFrom)}
                    onChange={e => {
                      this.setState({ dateFrom: e.format('YYYY-MM-DD') });
                    }}
                    inputProps={{
                      readOnly: true,
                      'data-cy': 'report-date-from',
                    }}
                  />
                </FormControl>
              </GridItem>
              <GridItem sm={3}>
                <FormLabel className={classes.labelHorizontal}>
                  {this.props.t('reports.forDriver.dateTo')} *
                </FormLabel>
                <FormControl fullWidth={true}>
                  <Datetime
                    className="input-datetime--date-to"
                    isValidDate={isDatepickerValidDay}
                    timeFormat={false}
                    dateFormat={moment.localeData().longDateFormat('L')}
                    closeOnSelect={true}
                    // eslint-disable-next-line new-cap -- FIXME
                    value={new moment(dateTo)}
                    onChange={e => {
                      this.setState({ dateTo: e.format('YYYY-MM-DD') });
                    }}
                    inputProps={{
                      readOnly: true,
                      'data-cy': 'report-date-to',
                    }}
                  />
                </FormControl>
              </GridItem>
              <GridItem sm={6}>
                <FormLabel className={classes.labelHorizontal}>
                  {this.props.t('reports.selectDeliveryType')}
                </FormLabel>
                <SelectInput
                  dataCy="report-delivery-type-select"
                  className="input-select--delivery-type"
                  noGrid={true}
                  classes={classes}
                  customStyle={customSelectStyles}
                  options={[
                    {
                      label: this.props.t('reports.doorDelivery'),
                      value: false,
                    },
                    {
                      label: this.props.t('reports.pickupPointDelivery'),
                      value: true,
                    },
                  ]}
                  trackBy={['value']}
                  mapBy="label"
                  value={selectedDeliveryPoint}
                  handleChange={selected => {
                    this.setState({
                      selectedDeliveryPoint: selected.target.value,
                      selectedZones: [],
                      selectedDrivers: [],
                    });
                  }}
                />
              </GridItem>
              {!selectedDeliveryPoint && (
                <>
                  <GridItem sm={6}>
                    <FormLabel className={classes.labelHorizontal}>
                      {this.props.t('reports.selectZoneCategories')}
                    </FormLabel>
                    <SelectAll
                      className="input-select--zone-category"
                      options={zoneCategories}
                      trackBy="id"
                      mapBy="name"
                      optionSelected={selectedZoneCategories}
                      handleChange={selected => {
                        this.setState({
                          selectedZoneCategories: selected,
                          selectedZones: [],
                        });
                      }}
                    />
                  </GridItem>
                  {filteredZones && filteredZones.length ? (
                    <GridItem sm={6}>
                      <FormLabel className={classes.labelHorizontal}>
                        {this.props.t('reports.selectZones')}
                      </FormLabel>
                      <SelectAll
                        className="input-select--filtered-zone"
                        options={filteredZones}
                        trackBy={['@id']}
                        mapBy="name"
                        optionSelected={selectedZones}
                        handleChange={selected => {
                          this.setState({
                            selectedZones: selected,
                          });
                        }}
                      />
                    </GridItem>
                  ) : null}
                </>
              )}
            </GridContainer>
            <GridContainer>
              {!this.state.selectedDeliveryPoint && (
                <GridItem sm={6}>
                  <FormLabel className={classes.labelHorizontal}>
                    {this.props.t('reports.selectDrivers')}
                  </FormLabel>
                  <SelectAll
                    className="input-select--driver"
                    options={drivers}
                    trackBy={['@id']}
                    mapBy="name"
                    selectAllLabel={this.props.t('report.forDriver.all')}
                    optionSelected={selectedDrivers}
                    handleChange={selected => {
                      this.setState({
                        selectedDrivers: selected,
                      });
                    }}
                  />
                </GridItem>
              )}
            </GridContainer>
            <GridContainer justify="flex-end">
              <GridItem>
                <DownloadReportButtons
                  isSalesMarketLangViewEnabled={true}
                  previewPdfAvailable={true}
                  previewXlsxAvailable={true}
                  mimeTypes={[MIME_TYPES.pdf, MIME_TYPES.xlsx]}
                  handlePreviewGenerate={this.handlePreviewGenerate}
                  handleGenerate={this.handleGenerate}
                  areButtonsDisabled={isGenerating}
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </CardWrapper>
        <Card>
          <CardBody>
            <Archive
              type={['REPORT']}
              reportName={['DELIVERY']}
              options={{
                drivers,
                zones,
              }}
            />
          </CardBody>
        </Card>
        <ReportPreview
          dateFrom={dateFrom}
          dateTo={dateTo}
          excelContent={excelContent}
          filePreview={filePreview}
          isOpen={isReportPreviewOpen}
          selectedBrands={selectedBrands}
          selectedDeliveryPoint={selectedDeliveryPoint}
          selectedDrivers={selectedDrivers}
          selectedZoneCategories={selectedZoneCategories}
          title={this.props.t('common.mainMenu.reportsForDriver')}
          useZoneCategories={true}
          downloadXls={() =>
            this.handleGenerate(MIME_TYPES.xlsx, DEFAULT_SALES_MARKET_LANG)
          }
          downloadPdf={this.downloadPdf}
          onClose={() => {
            this.setState({ isReportPreviewOpen: false });
          }}
        />
      </>
    ) : (
      <AccessDenied />
    );
  }
}

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

const mapStateToProps = state => ({
  brands: state.Auth.user.brands,
  company: state.Auth.user.company,
  selectedBrand: state.Auth.user.selectedBrand,
  zones: state.Zones.zones,
  zoneCategories: state.ZoneCategories.zoneCategories,
  drivers: state.Drivers.drivers,
  deliveryTypes: state.DeliveryTypes.deliveryTypes,
});

const mapDispatchToProps = dispatch => ({
  fetchDrivers: () => dispatch(fetchDrivers()),
  fetchZones: () => dispatch(fetchZones()),
  fetchDeliveryTypes: () => dispatch(fetchDeliveryTypes()),
  fetchZoneCategories: () => dispatch(fetchZoneCategories()),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(combinedStyles),
  withTranslation()
);

export default enhance(ForDriver);
